"use strict";

exports.__esModule = true;
exports.default = void 0;

var _uiSchema = _interopRequireDefault(require("../../roles/uiSchema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = {
  "ui:layout": "section",
  "ui:title": "Oppgave",
  "ui:preview": {
    "select": {
      "description": "description"
    },

    prepare({
      formData
    }) {
      return {
        description: formData && formData.title || "Uten tittel"
      };
    }

  },
  "ui:label": false,
  "ui:options": {
    "grid": true,
    "spacing": 2,
    "collapsible": true
  },
  "ui:fieldset": ["title", "description", "priorityId", "status", "startedAt", "completedAt", "roles"],
  "title": {
    "ui:title": "Tittel"
  },
  "description": {
    "ui:title": "Beskrivelse",
    "ui:widget": "textarea"
  },
  "priorityId": {
    "ui:title": "Prioritet",
    "ui:widget": "primusPriority"
  },
  "status": {
    "ui:title": "Status",
    "ui:widget": "radio",
    "ui:inline": true
  },
  "startedAt": {
    "ui:title": "Startdato"
  },
  "completedAt": {
    "ui:title": "Utørt dato"
  },
  "roles": _uiSchema.default
};
exports.default = _default;
module.exports = exports.default;